var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 48,
    viewBox: "0 0 36 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9141 35.1984L33.1652 35.9473L32.4163 35.1984L32.4163 12.732L33.1652 11.9831L33.9141 12.732L33.9141 35.1984Z",
    fill: "url(#paint0_linear_13949_33989)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96094 35.1984L3.21206 35.9473L2.46318 35.1984L2.46318 12.732L3.21206 11.9831L3.96094 12.732L3.96094 35.1984Z",
    fill: "url(#paint1_linear_13949_33989)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4297 41.1906L25.6808 41.9395L24.9319 41.1906L24.9319 6.74209L25.6808 5.99321L26.4297 6.74209L26.4297 41.1906Z",
    fill: "url(#paint2_linear_13949_33989)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4531 41.1925L10.7042 41.9414L9.95536 41.1925L9.95536 6.74404L10.7042 5.99516L11.4531 6.74404L11.4531 41.1925Z",
    fill: "url(#paint3_linear_13949_33989)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9453 47.1789L18.1964 47.9277L17.4476 47.1789L17.4475 0.748295L18.1964 -0.000583583L18.9453 0.748295L18.9453 47.1789Z",
    fill: "url(#paint4_linear_13949_33989)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 45.7881L18.1909 47.9277L15.9442 45.7881L15.9442 27.601L18.1909 25.4613L20.4375 27.601L20.4375 45.7881Z",
    fill: "#050503"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9453 39.7998L10.6987 41.9395L8.45203 39.7998L8.45203 30.5993L10.6987 28.4596L12.9453 30.5993L12.9453 39.7998Z",
    fill: "#050503"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46094 33.8076L3.2143 35.9473L0.967657 33.8076L0.967657 33.5936L3.2143 31.454L5.46094 33.5936L5.46094 33.8076Z",
    fill: "#050503"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9297 39.8017L25.683 41.9414L23.4364 39.8017L23.4364 24.6102L25.683 22.4705L27.9297 24.6102L27.9297 39.8017Z",
    fill: "#050503"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4141 33.8076L33.1674 35.9473L30.9208 33.8076L30.9208 21.6116L33.1674 19.4719L35.4141 21.6116L35.4141 33.8076Z",
    fill: "#050503"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13949_33989",
    x1: 33.1652,
    y1: 35.9473,
    x2: 33.1652,
    y2: 11.9831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F2441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2441",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13949_33989",
    x1: 3.21206,
    y1: 35.9473,
    x2: 3.21206,
    y2: 11.9831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F2441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2441",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13949_33989",
    x1: 25.6808,
    y1: 41.9395,
    x2: 25.6808,
    y2: 5.99321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F2441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2441",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13949_33989",
    x1: 10.7042,
    y1: 41.9414,
    x2: 10.7042,
    y2: 5.99516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F2441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2441",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13949_33989",
    x1: 18.1964,
    y1: 47.9277,
    x2: 18.1964,
    y2: -0.000583583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F2441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2441",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellowIcon);
export default __webpack_public_path__ + "static/media/bellow-icon.c3c0edf261025ef87897753121891534.svg";
export { ForwardRef as ReactComponent };